var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaiIcSignal0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70711 0.292893C1.31658 -0.0976311 0.683418 -0.0976311 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L18.8082 17.394C19.5322 16.8463 20 15.9778 20 15V5C20 3.34315 18.6569 2 17 2C15.3431 2 14 3.34315 14 5V12.5858L13.0002 11.586V9C13.0002 7.34315 11.657 6 10.0002 6C9.27667 6 8.61352 6.25634 8.09605 6.68184L1.70711 0.292893ZM16 14.5858L17.3509 15.9367C17.7301 15.7946 18 15.4288 18 15V5C18 4.44772 17.5523 4 17 4C16.4477 4 16 4.44772 16 5V14.5858ZM11.0002 9V9.58597L9.53081 8.1166C9.67101 8.04199 9.83082 8 10.0002 8C10.5525 8 11.0002 8.44772 11.0002 9Z",
    fill: "#008AD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13C0 11.3431 1.34315 10 3 10C4.65685 10 6 11.3431 6 13V15C6 16.6569 4.65685 18 3 18C1.34315 18 0 16.6569 0 15V13ZM3 12C2.44772 12 2 12.4477 2 13V15C2 15.5523 2.44772 16 3 16C3.55228 16 4 15.5523 4 15V13C4 12.4477 3.55228 12 3 12Z",
    fill: "#008AD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8.55229 12 9 12.4477 9 13V15C9 15.5523 9.44772 16 10 16C10.2985 16 10.5656 15.8704 10.7503 15.6612C11.1157 15.2471 11.7477 15.2077 12.1617 15.5732C12.5758 15.9386 12.6152 16.5706 12.2497 16.9846C11.7015 17.6058 10.8962 18 10 18C8.34315 18 7 16.6569 7 15V13C7 12.4477 7.44772 12 8 12Z",
    fill: "#008AD2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaiIcSignal0);
export default __webpack_public_path__ + "static/media/mai-ic-signal-0.48bf7da57f081024e10ca207cee64650.svg";
export { ForwardRef as ReactComponent };